import type { SVGProps } from 'react';

/**
 * CE conformity marking with the legally prescribed proportions
 * (Regulation (EC) 765/2008 Annex II / MDR Annex V).
 *
 * Geometry from https://commons.wikimedia.org/wiki/File:Conformité_Européenne_(logo).svg
 * (Public Domain), recolored to `currentColor`.
 */
export function CeMark(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            viewBox="0 0 280 200"
            fill="currentColor"
            fillRule="evenodd"
            role="img"
            aria-label="CE marking"
            {...props}
        >
            <path d="M110,199.498744A100,100 0 0 1 100,200A100,100 0 0 1 100,0A100,100 0 0 1 110,0.501256L110,30.501256A70,70 0 0 0 100,30A70,70 0 0 0 100,170A70,70 0 0 0 110,169.498744Z" />
            <path d="M280,199.498744A100,100 0 0 1 270,200A100,100 0 0 1 270,0A100,100 0 0 1 280,0.501256L280,30.501256A70,70 0 0 0 270,30A70,70 0 0 0 201.620283,85L260,85L260,115L201.620283,115A70,70 0 0 0 270,170A70,70 0 0 0 280,169.498744Z" />
        </svg>
    );
}
